import router from '@/router'
import promotionService from '@/services/promotion'
import _ from 'lodash'
import userService from '@/services/user'
import moment from 'moment-timezone'
import Vue from 'vue'
import {
    stat,
    truncateSync
} from 'fs';
import {
    ValidationProvider
} from 'vee-validate'
const state = {
    loadData: true,
    first_time: false,
    checkBackdrop: false,
    userdb: {
        code: null,
        boss_code: null
    },
    promotions_all: [],
    promotions: [],
    display_promotions: [],
    mng_condition_list: [{
            id: 1,
            name: 'Track'
        },
        {
            id: 5,
            name: 'Cancel Tracking'
        },
        {
            id: 2,
            name: 'Duplicate'
        },
        {
            id: 3,
            name: 'Edit'
        },
        {
            id: 4,
            name: 'Delete'
        },
        {
            id: 6,
            name: 'Inactive Promo'
        }
    ],
    mng_strategies_list: [{
        id: 1,
        name: 'Brand'
    }],
    show_apv_dialog: false,
    show_memo_dialog: false,
    promo_selected: [],
    filterProduct: [],
}
const mutations = {
    setFilterProduct(state, value) {
        state.filterProduct = value
    },
    setPromotionsAll(state, value) {
        state.promotions_all = value
    },
    setPromotions(state, value) {
        state.promotions = value
    },
    setDisplayPromotions(state, value) {
        state.display_promotions = value
    },
    openApvDialog(state, rows) {
        state.show_apv_dialog = true
        state.promo_selected = rows
    },
    closeApvDialog(state) {
        state.show_apv_dialog = false
        state.promo_selected = []
    },
    openMemoDialog(state) {
        state.show_memo_dialog = true
    },
    closeMemoDialog(state) {
        state.show_memo_dialog = false
        // state.promo_selected = []
    },
    sendApvDialog(state) {
        state.show_apv_dialog = false
    },
    setUserDB(state, value) {
        state.userdb.code = value.code
        state.userdb.boss_code = value.boss_code
    },
    loadingPage(state, value) {
        state.loadData = value
        state.checkBackdrop = value
    },
    firstTime(state, value) {
        state.first_time = value
    }
}
const actions = {
    getUserDB: ({
        commit
    }) => {
        var user = Vue.$jwt.decode(localStorage.getItem('token'))
        userService.getInfo(user.id)
            .then((response) => {
                commit('setUserDB', response)
            }).catch((error) => console.log(error))
    },
    getPromotions: ({
        commit
    }) => {
        let user = Vue.$jwt.decode(localStorage.getItem('token'))
        promotionService.getPromotions(user.code, 'Present')
            //promotionService.getPromotions(state.userdb.code)
            .then((response) => {
                // console.log("- GET PROMOTION -", state.first_time);
                commit('setPromotions', response)
                commit('setPromotionsAll', response)
                commit('loadingPage', false)
                commit('firstTime', false)
            })
            .catch((error) => console.log(error))
    },
    searchPromotion: ({
        commit
    }, {
        type_search,
        status,
        strategies,
        duration,
        keyword,
        custgroup,
        prodgroup,
        createuser
    }) => {
        // console.log("- searchPromotion -", custgroup);
        if (type_search !== 'duration') {
            console.log("-IF-", state.promotions_all);
            keyword = keyword.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
            var re = new RegExp(keyword, 'gi')
            var response = _.filter(state.promotions_all, (item) => {
                // if (status !== 'ALL') {
                //     /* filter with status */
                //     if (status === 'Active' && item.promotion_active != true) {
                //         return false;
                //     } else if (status === 'Draft' && item.type !== 'draft') {
                //         return false;
                //     } else if (status === 'Pending' && item.type !== 'send') {
                //         return false;
                //     }
                // }

                if (status !== 'ALL') {
                    /* filter with status */
                    if (status === 'Active' && item.type != "Active") {
                        return false;
                    } else if (status === 'Draft' && (item.type !== 'Draft' || (item.type_active))) {
                        return false;
                    } else if (status === 'Pending' && item.type !== 'Pending') {
                        return false;
                    } else if (status === 'Return' && item.type !== 'Return') {
                        return false;
                        // } else if (status === 'Inactive' && (!item.type_active || item.type_active === undefined || item.type == 'Active')) {
                    } else if (status === 'Inactive' && (!item.type_active || item.type_active === undefined || item.type !== 'Draft')) {
                        return false;
                    }
                }

                if (duration !== '') {
                    var now = moment();
                    var startdate = moment(new Date(item.startdate))
                    var enddate = moment(new Date(item.enddate))
                    // if (duration == 'Present' && (startdate > now || enddate < now)) {
                    //     return false;
                    //     // if (duration == 'Present' && (startdate <= now && enddate >= now)) {
                    //     //     return true;
                    // } else 
                    if (duration == 'Future' && startdate <= now) {
                        console.log("Future");
                        return false;
                    } else if (duration == 'Old' && enddate >= now) {
                        console.log("Old");
                        return false;
                    }
                    // else if (duration == 'Present' && (startdate !== now || (startdate < now && enddate < now) || (startdate > now && enddate > now))) {
                    //     console.log("Present");
                    //     return false;
                    // }
                }

                // console.log("-----");
                // console.log("-----", prodgroup, custgroup, createuser);

                if (prodgroup !== '') {
                    let hasProdGroup = false;
                    // console.log("item.products ==>", item.products);
                    // console.log("prodgroup ==>", prodgroup);
                    for (let index in item.products) {
                        if (item.products[index].code === prodgroup) {
                            hasProdGroup = true;
                            break;
                        }
                    }
                    if (hasProdGroup === false) {
                        return false;
                    }
                }
                if (custgroup !== '') {
                    /* filter with customer group */
                    let hasCustGroup = false;
                    for (let index in item.sets) {
                        let set = item.sets[index];
                        for (let key in set.customers) {
                            // if (set.customers[key]._id === custgroup) {
                            if (set.customers[key].group_code === custgroup) {
                                hasCustGroup = true;
                                break;
                            }
                        }
                    }
                    if (hasCustGroup === false) {
                        return false;
                    }
                }
                if (createuser !== '') {
                    // console.log("createuser ==>", createuser, item.c_user);
                    if (createuser !== item.c_user) {
                        return false;
                    }
                }

                // if (duration == 'Present' && (startdate <= now && enddate >= now)) {
                //     return true;
                // }
                // if (duration === 'Present' && (startdate < now || enddate > now)) {
                //     return false;
                // }

                if (item.promotion_code !== null && item.promotion_code.match(re)) {
                    return true
                } else if (item.promotion_title !== null && item.promotion_title.match(re)) {
                    return true
                    //            }else if (item.promotion_detail !== null && item.promotion_detail.match(re)){
                    //                return true
                }
            });
            // console.log("- SEARCH -", response);
            commit('setPromotions', response)
            commit('loadingPage', false);
        } else {
            // console.log("-ELSE-");
            commit('firstTime', true)
            let user = Vue.$jwt.decode(localStorage.getItem('token'))
            promotionService.getPromotions(user.code, duration).then((rs) => {
                commit('setPromotionsAll', rs);

                keyword = keyword.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
                var re = new RegExp(keyword, 'gi')
                var response = _.filter(rs, (item) => {

                    if (status !== 'ALL') {
                        /* filter with status */
                        if (status === 'Active' && item.type != "Active") {
                            return false;
                        } else if (status === 'Draft' && (item.type !== 'Draft' || (item.type_active))) {
                            return false;
                        } else if (status === 'Pending' && item.type !== 'Pending') {
                            return false;
                        } else if (status === 'Return' && item.type !== 'Return') {
                            return false;
                        } else if (status === 'Inactive' && (!item.type_active || item.type_active === undefined || item.type == 'Active')) {
                            return false;
                        }
                    }

                    // if (duration !== '') {
                    //     var now = moment();
                    //     var startdate = moment(new Date(item.startdate))
                    //     var enddate = moment(new Date(item.enddate))
                    //     if (duration == 'Present' && (startdate > now || enddate < now)) {
                    //         return false;
                    //     } else if (duration == 'Future' && startdate <= now) {
                    //         return false;
                    //     } else if (duration == 'Old' && enddate >= now) {
                    //         return false;
                    //     }
                    // }

                    if (prodgroup !== '') {
                        let hasProdGroup = false;
                        for (let index in item.products) {
                            if (item.products[index].code === prodgroup) {
                                hasProdGroup = true;
                                break;
                            }
                        }
                        if (hasProdGroup === false) {
                            return false;
                        }
                    }
                    if (custgroup !== '') {
                        /* filter with customer group */
                        let hasCustGroup = false;
                        for (let index in item.sets) {
                            let set = item.sets[index];
                            for (let key in set.customers) {
                                // if (set.customers[key]._id === custgroup) {
                                if (set.customers[key].group_code === custgroup) {
                                    hasCustGroup = true;
                                    break;
                                }
                            }
                        }
                        if (hasCustGroup === false) {
                            return false;
                        }
                    }

                    if (createuser !== '') {
                        if (createuser !== item.c_user) {
                            return false;
                        }
                    }
                    if (item.promotion_code !== null && item.promotion_code.match(re)) {
                        return true
                    } else if (item.promotion_title !== null && item.promotion_title.match(re)) {
                        return true
                        //            }else if (item.promotion_detail !== null && item.promotion_detail.match(re)){
                        //                return true
                    }
                });
                commit('setPromotions', response)
                commit('loadingPage', false);
            }).catch((error) => console.log(error));
        }
    },
    async deletePromotion({
        commit,
        state
    }, {
        promotion,
        index
    }) {
        // deletePromotion: ({
        //     state
        // }, {
        //     promotion,
        //     index
        // }) => {
        let check_delete = (promotion.type == "Draft" && (promotion.type_active === undefined || promotion.type_active == false)) ? "delete" : "";
        let datas = {
            "_id": promotion._id,
            //    "type" : "Inactive"
            "type": "Delete",
            "check_delete": check_delete
        };
        datas.u_time = moment(new Date()).format('YYYY-MM-DD HH:mm')

        let user = Vue.$jwt.decode(localStorage.getItem('token'))
        var user_db
        await userService.getInfo(user.id)
            .then((response) => {
                user_db = response
            })
        if (user_db.code) {
            datas.u_user = user_db.code
        }

        // promotionService.deletePromotion(promotion._id)
        await promotionService.updatePromotion(datas)
            .then((rs) => {
                state.promotions.splice((index * 1), 1)
                return rs;
            })
            .catch((error) => console.log(error))
    },
    trackPromo: ({
        commit
    }, {
        row,
        index
    }) => {
        let datas = {
            "_id": row._id,
            "user_code": row.c_user
        };
        promotionService.Track(datas)
            .then(() => {
                // console.log("TRACK");
                // state.promotions[index].track.push(row.c_user);
            })
            .catch((error) => console.log(error))

        // router.replace('/promotion/track')
        // commit('closeApvDialog')
    }
}
const getters = {
    show_apv_dialog: state => {
        return state.show_apv_dialog
    },
    show_memo_dialog: state => {
        return state.show_memo_dialog
    },
    promo_selected: state => {
        return state.promo_selected
    },
    filterProduct: state => {
        return state.filterProduct
    },
    promotions: state => {
        return state.promotions
    },
    display_promotions: state => {
        return state.display_promotions
    },
    mng_condition_list: state => {
        return state.mng_condition_list
    },
    mng_strategies_list: state => {
        return state.mng_strategies_list
    },
    userdb: state => {
        return state.userdb
    },
    loadData: state => {
        return state.loadData
    },
    first_time: state => {
        return state.first_time
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};